import { Text } from "@chakra-ui/react";
import * as React from "react";

import { HorizontalDivider } from "../Elements";

type FormSectionProps = {
  name: string;
  children: React.ReactNode;
};

export const FormSection = ({ name, children }: FormSectionProps) => {
  return (
    <>
      <Text marginTop="2rem" fontSize="1.25rem" fontWeight="bolder">
        {name}
      </Text>
      <HorizontalDivider />
      {children}
    </>
  );
};
